<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-add-product"
      centered
      button-size="sm"
      v-on:hide="hideModal"
      v-on:close="hideModal"
    >
      <template #modal-title>
        <i class="fas fa-plus"></i>&nbsp; ADICIONAR PRODUTO
      </template>
      <NxSelectProduto
          :multiple="false"
          :initialValue="(form.product !== undefined && form.product !== null) ? this.form.product : null"
          @update:value="handleSelectUpdate('product', $event)"
      />
      <NxSelectTipoMeta
        :initialValue="(form.type !== undefined && form.type !== null) ? this.form.type : null"
        @update:value="handleSelectUpdate('type', $event)"
      />
      <div class="d-flex">
        <NxInput
          class="w-50 mr-2"
          name="lock"
          v-model="form.lock"
          type="number"
          label="Trava:"
          placeholder="Digite a trava"
          validation="max:3,length"
          :validation-messages="{ max: `Limite de 3 dígitos.`}"
          error-behavior="live"
          @update:value="handleInputUpdate('lock', $event)" />
        <NxInput
          class="w-50"
          name="strenght"
          v-model="form.strenght"
          type="number"
          label="Peso:"
          placeholder="Digite o peso"
          validation="max:3,length"
          :validation-messages="{ max: `Limite de 3 dígitos.`}"
          error-behavior="live"
          @update:value="handleInputUpdate('strenght', $event)" />
      </div>
      <div class="d-flex">
        <NxRadioButton
          class="w-50 mr-2"
          :initialValue="(form.quantityOrAmount !== undefined && form.quantityOrAmount !== null) ? form.quantityOrAmount : null"
          label="Tipo de Métrica"
          name="choose_metric"
          :listOptions="[
            { value: ListGoalMetricTypes.QUANTITY, text: 'Quantidade' },
            { value: ListGoalMetricTypes.AMOUNT, text: 'Valor' },
            { value: ListGoalMetricTypes.PERCENTAGE, text: 'Porcentagem' }
          ]"
          @update:value="handleInputUpdate('quantityOrAmount', $event)"
        />
        <NxInput
          class="w-50"
          v-show="
            form.quantityOrAmount === ListGoalMetricTypes.QUANTITY ||
            form.quantityOrAmount === ListGoalMetricTypes.AMOUNT ||
            form.quantityOrAmount === ListGoalMetricTypes.PERCENTAGE
          "
          name="quantityOrAmountValue"
          type="number"
          v-model="form.quantityOrAmountValue"
          validation="min:1"
          :validation-messages="{ min: `O valor deve ser maior do que 0.`}"
          :label="
            form.quantityOrAmount === ListGoalMetricTypes.QUANTITY
              ? 'Digite a Quantidade:'
              : form.quantityOrAmount === ListGoalMetricTypes.AMOUNT
                ? 'Digite o R$:'
                : 'Digite a %:'
          "
          :placeholder="
            form.quantityOrAmount === ListGoalMetricTypes.QUANTITY
              ? 'Quantidade'
              : form.quantityOrAmount === ListGoalMetricTypes.AMOUNT
                ? 'R$'
                : '%'
          "
          @blur="validateIntegerInputOnBlur"
          @update:value="handleInputUpdate('quantityOrAmountValue', $event)"
        ></NxInput>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn rounded btn-default btn-sm text-secundary"
            v-on:click="onClear"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonClear"
          >
            <i class="fa fa-minus-circle"></i>
            <span class="d-md-down-none">{{
              $lang.Common.Buttons.Clear
            }}</span></button
          >&nbsp;
                  <button
                    :disabled="checkFields || isSaving"
                    type="button"
                    class="btn rounded btn-third btn-sm"
                    v-on:click.prevent="onSave"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonSave"
                  >
            <i v-if="!isSaving" class="fa fa-check-circle"></i>
            <i v-else class="fa fa-spinner fa-spin"></i>
            <span class="d-md-down-none">{{
              isSaving ? 'Salvando...' : $lang.Common.Buttons.Save
            }}</span></button
          >&nbsp;
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  NxSelectProduto,
  NxSelectTipoMeta
} from '@/components/nexum/components/custom-selects/index.js'
import { ListGoalMetricTypes, ListGoalPeriods } from '@/enums/enumGoalMetricTypes.js'
import GoalRepository from '@/shared/http/repositories/metas/metas.js'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'ModalAddProduto',
  components: { NxSelectProduto, NxSelectTipoMeta },
  props: ['gerenteId', 'periodicity', 'referencePeriod', 'productEditing'],
  data () {
    return {
      ListGoalMetricTypes: ListGoalMetricTypes,
      ListGoalPeriods: ListGoalPeriods,
      isSaving: false, // Flag para controlar múltiplos cliques
      form: {
        product: null,
        type: null,
        lock: null,
        strenght: null,
        quantityOrAmount: null,
        quantityOrAmountValue: null
      }
    }
  },
  mounted () {
    if (this.productEditing !== null) {
      this.fillForm()
    }
    this.showModal()
  },
  computed: {
    checkFields () {
      // Desabilita o botão se estiver salvando ou se os campos obrigatórios não estão preenchidos
      if (this.isSaving) {
        return true
      }
      if (this.form.quantityOrAmountValue <= 0) {
        return true
      }
      for (let key in this.form) {
        if (this.form.hasOwnProperty(key)) {
          if (this.form[key] === null || this.form[key] === undefined) {
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-add-product'].show()
    },
    hideModal () {
      this.$emit('Close')
    },
    handleInputUpdate (fieldName, inputedValue, clean = false) {
      if (inputedValue !== null) {
        this.form[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },

    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
          typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map(v => v.value)
          : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    onClear () {
      this.$root.$emit('clearForm')
      for (let key in this.form) {
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = null
        }
      }
    },
    clearField (field) {
      if (field !== null) this.form[field] = null
    },
    onSave (event) {
      // Previne múltiplos cliques - verifica se já está salvando
      if (this.isSaving) {
        return false
      }

      // Desabilita o botão imediatamente no primeiro clique
      this.isSaving = true

      // Executa a operação apropriada
      if (this.productEditing === null) {
        this.createProduct()
      } else {
        this.updateProduct()
      }

      return false // Previne qualquer comportamento padrão
    },
    async createProduct () {
      let data = this.formToData()

      try {
        await GoalRepository.CreateProduct(data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.$emit('Reload')
        this.hideModal() // Fecha o modal após sucesso

        // Aguarda o modal fechar completamente antes de resetar isSaving
        setTimeout(() => {
          this.isSaving = false
        }, 1000)

        return true
      } catch (error) {
        toast.error('Produto já cadastrado para meta!', 'Erro')
        console.error(error)

        // Em caso de erro, reseta imediatamente já que a requisição falhou
        this.isSaving = false

        return false
      }
    },
    async updateProduct () {
      let data = this.formToData()
      let productGoalId = this.productEditing.id

      try {
        await GoalRepository.UpdateProduct(productGoalId, data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.$emit('Reload')
        this.hideModal() // Fecha o modal após sucesso

        // Aguarda o modal fechar completamente antes de resetar isSaving
        setTimeout(() => {
          this.isSaving = false
        }, 1000)

        return true
      } catch (error) {
        toast.error('Erro ao atualizar produto!', 'Erro')
        console.error(error)

        // Em caso de erro, reseta imediatamente já que a requisição falhou
        this.isSaving = false

        return false
      }
    },
    formToData () {
      let data = {
        produtoId: this.form.product,
        tipo: this.form.type,
        peso: this.form.strenght,
        trava: this.form.lock,
        tipoMeta: this.form.quantityOrAmount,
        gerenteCarteiraId: this.gerenteId,
        periodicidade: this.periodicity,
        referenciaPeriodo: this.referencePeriod,
        valorMeta: this.form.quantityOrAmountValue
      }
      return data
    },
    fillForm () {
      console.log('fillForm', this.productEditing)
      this.form = {
        product: this.productEditing.produto.id,
        type: this.productEditing.tipo,
        lock: this.productEditing.trava,
        strenght: this.productEditing.peso,
        quantityOrAmount: this.productEditing.tipoMeta,
        quantityOrAmountValue: this.productEditing.valorMeta
      }
    },
    validateIntegerInputOnBlur (event) {
      if (this.form.quantityOrAmount === ListGoalMetricTypes.QUANTITY) {
        const value = event.target.value
        if (!Number.isInteger(Number(value))) {
          event.target.value = Math.floor(value)
          this.form.quantityOrAmountValue = Math.floor(value)
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .formulate-input-element.formulate-input-element {
    max-width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/metas-gerente/add/ModalAddProduto.vue